import { SHOW_IMAGE_PREVIEW_MODAL, HIDE_IMAGE_PREVIEW_MODAL } from './actionTypes';

export function showImagePreviewAction({ images = [] }) {
  return {
    type: SHOW_IMAGE_PREVIEW_MODAL,
    data: { images },
  };
}

export function hideImagePreviewAction() {
  return {
    type: HIDE_IMAGE_PREVIEW_MODAL,
  };
}
